import { render } from "./costing_notification.vue?vue&type=template&id=76684b00"
import script from "./costing_notification.vue?vue&type=script&lang=js"
export * from "./costing_notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__